Vue.component('ack-shop-3dps-filters', {
  delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
  template: '#ack-shop-3dps-filters',
  props:{
    isMobile: {
      type: Boolean
    }
  },
  data() {
    return {
      investRangeValue: null,// {max: 100, min: 0},
      applicationsRangeValue: null,
      selectedApplications: null
    }
  },
  computed: {
    //...Vuex.mapGetters('navBar', ['switchMobileDropdowns']),
    // isMobile(){
    //   return this.$parent.isMobile
    // }
  },
  mounted() {
    appLog.log('ack-shop-3dps-filters mounted', LOG_TYPE.debug)
    
    
  },
  methods: {
    //...Vuex.mapActions(['sayHi', 'someAction']),
    //...Vuex.mapActions('navBar', ['sayHi', 'closeAllMobileDropdowns'])   
    loadBundle(bundleTag){
      this.$emit('load-bundle', bundleTag)
    }
  },
  beforeDestroy() {
    
  },
  watch: {
    investRangeValue: {
      handler() {
        
        appLog.log('investRangeValue changed', LOG_TYPE.debug)
        appLog.log(this.investRangeValue, LOG_TYPE.varDump)
      },
      deep: true
    },
    applicationsRangeValue: {
      handler() {
        
        appLog.log('applicationsRangeValue changed', LOG_TYPE.debug)
        appLog.log(this.applicationsRangeValue, LOG_TYPE.varDump)
      },
      deep: true
    },
    selectedApplications: {
      handler() {
        
        appLog.log('selectedApplications changed', LOG_TYPE.debug)
        appLog.log(this.selectedApplications, LOG_TYPE.varDump)
      },
      deep: true
    }
  }
})